function paymentOnload(method) {

    if ($('#method').val() == 'cartao') {
        // escolha do proprietario do cartão
        $('#billing_data_register').click(function (e) {
            $('.billing-data-content').fadeOut('slow');
        });
        $('#billing_data_other').click(function (e) {
            $('.billing-data-content').fadeIn('slow');
        });

        selectStateCity('state', 'city');
        zipCodeSearchOnload();
    }

    /*
     * VALIDAÇÂO DE CARTÂO
     */

    // validação do número do cartão - luhnCheck (Source: http://rosettacode.org/wiki/Luhn_test_of_credit_card_numbers)
    // var luhnCheck = function (a, b, c, d, e) {
    //     for (d = +a[b = a.length - 1], e = 0; b--;)
    //         c = +a[b], d += ++e % 2 ? 2 * c % 10 + (c > 4) : c;
    //     // console.log(!(d%10))
    //     return !(d % 10);
    // };

    // validacao do cartão e modificação do estado do input
    // function validCard(cardNumber) {
    //     cardNumber = cardNumber.replace(/-/g, '');
    //     var input_card = $('#card_number');
    //
    //     if (cardNumber != "") {
    //         if (luhnCheck(cardNumber) == true && $.isNumeric(cardNumber)) {
    //             //console.log("true = " + cardNumber);
    //             input_card.removeClass("is-invalid");
    //             $('#label_card_error').removeClass("d-block");
    //             $('#label_card_error').addClass("d-none");
    //         } else {
    //             //console.log("false = " + cardNumber);
    //             input_card.addClass("is-invalid");
    //             $('#label_card_error').removeClass("d-none");
    //             $('#label_card_error').addClass("d-block");
    //             input_card.focus();
    //         }
    //     }
    // };

    // ao perder o foco do input do cartão, faz a validação
    // var countKeypress = 0;
    // $('#card_number').blur(function () {
    //     validCard(this.value);
    //     countKeypress++;
    //     // chama keyup após o primeiro focus out
    //     if (countKeypress == 1) {
    //         $('#card_number').keyup(function () {
    //             validCard(this.value);
    //         });
    //     }
    // });


    /*
     * SUBMIT FORM
     */
    $("#form_payment").submit(function(e) {
        e.preventDefault();

        // desabilita botão
        $('#submitPayment').prop('disabled', true);

    }).validate({
        rules: {
            payment_form: "required",
            card_number: "required",
            holder_name: "required",
            valid_month: "required",
            valid_year: "required",
            security_code: {
                required: true,
                number: true
            },
            email: {
                required: true,
                email: true
            },
            first_name: "required",
            last_name: "required",
            document: "required",
            gender: "required",
            birth_date: "required",
            cell_phone: "required",
            street: "required",
            number: {
                required: true,
                number: true
            },
            district: "required",
            state: "required",
            city: "required",
            zip_code: "required",
        },
        messages: {
            valid_month: {required: "" },
            valid_year: {required: "" },
        },
        errorElement: "span",
        errorPlacement: function (error, element) {
            element.addClass("is-invalid");
            error.insertAfter(element).addClass("form-text").addClass("text-danger");

            // habilita botão
            $('#submitPayment').prop('disabled', false);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass("is-invalid");

            // habilita botão
            $('#submitPayment').prop('disabled', false);
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass("is-invalid");
            $(element > "small").fadeOut();
        },
        // SUBMIT AJAX
        submitHandler: function(form) {
            var form = $("#form_payment");
            var flashClass = "ajax_response";
            var flash = $("." + flashClass);
            var modal_size = "sm";
            var modal = "#modal_" + modal_size;
            var modal_title = $(".modal_title_" + modal_size);
            var modal_content = $(".modal_content_" + modal_size);

            grecaptcha.ready(function() {
                grecaptcha.execute('6Ld8hP8UAAAAALeKcOL8mdRqtJGj0WOSZg6A222O', {action: 'submit'}).then(function(token) {

                    form.ajaxSubmit({
                        url: form.attr("action"),
                        type: "POST",
                        data: {token: token},
                        dataType: "json",
                        beforeSend: () => {
                            loaderShow();
                        },
                        success: (response) => {

                            //redirect
                            if (response.redirect) {
                                window.location.href = response.redirect;
                            } else {
                                loaderClose();
                            }

                            //message flash
                            if (response.message_flash) {
                                if (flash.length) {
                                    flash.html(response.message_flash).fadeIn(100);
                                } else {
                                    form.prepend("<div class='" + flashClass + "'>" + response.message_flash + "</div>")
                                        .find("." + flashClass);
                                }
                            }

                            //message
                            if (response.message) {
                                setTimeout(function() {
                                    modal_title.html("Ops!");
                                    modal_content.html(response.message);
                                    openModal(modal);
                                }, 400);
                            }

                            // habilita botão
                            $('#submitPayment').prop('disabled', false);

                        },
                        complete: function () {
                            if (form.data("reset") === true) {
                                form.trigger("reset");
                            }
                        },
                        // error: function (request, status, error) {
                        error: function (xhr, status, error) {

                            var message = "<div class='message error icon-warning'>Desculpe mas não foi possível processar a requisição. Favor tente novamente!</div>";

                            setTimeout(function() {
                                modal_title.html("Ops!");
                                modal_content.html(message);
                                openModal(modal);
                            }, 400);

                            loaderClose();

                            // habilita botão
                            $('#submitPayment').prop('disabled', false);

                            // var error = "Status: " + request.status + " - Response: " + request.responseText + " - Error:" + error;
                            // $.post(url("/log/error"), {platform:'ticket', origin:'pagamento', description:error});

                            var errorMessage = xhr.status + ': ' + xhr.responseText + " - " + status + " - " + error;
                            $.post(url("/log/error"), {platform:'ticket', origin:'pagamento', description:errorMessage});
                        }
                    });

                });
            });

            return false;
        }
    });

    //CONSULT ORDER STATUS WITH PIX
    if (method == 'pix') {
        setInterval(() => {
            $.ajax({
                url: window.location.href,
                data: 'action=consult',
                type: 'POST',
                dataType: 'JSON',
                success: (response) => {
                    if (response.redirect) {
                        window.location.href = response.redirect;
                    }
                }
            });
        }, 1000 * 10);
    }

}